module.exports = __webpack_public_path__ + "img/paris.577f50ef.png";